const byOrdinality = (a, b) => a.ordinality - b.ordinality;

const getQuestionsFromSections = sections =>
    sections
        .sort(byOrdinality)
        .flatMap(s => s.content.sort(byOrdinality))
        .filter(c => c.question_key);

export default getQuestionsFromSections;
